import AsyncStorage from "@react-native-async-storage/async-storage";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import {
  ShopkeeperDetailSchemaType,
  ShopkeeperResponseSchemaDTO,
  StoreDetailResponseSchemaDTO,
  StoreDetailSchemaType
} from "@repo/core/services/entities/Proposals";

interface StoresAndShopkeepersState {
  selectedStore: StoreDetailSchemaType | null;
  selectedShopkeeper: ShopkeeperDetailSchemaType | null;
  availableStores: StoreDetailResponseSchemaDTO;
  availableShopkeepers: ShopkeeperResponseSchemaDTO;
  hasMoreThanOneShopkeeper: boolean;
  hasMoreThanOneStore: boolean;
  showCorrectStoreAlert: boolean;
  setSelectedStore: (store: StoreDetailSchemaType | null) => void;
  setSelectedShopkeeper: (
    shopkeeper: ShopkeeperDetailSchemaType | null
  ) => void;
  setAvailableStores: (stores: StoreDetailResponseSchemaDTO) => void;
  setAvailableShopkeepers: (shopkeepers: ShopkeeperResponseSchemaDTO) => void;
  setShowCorrectStoreAlert: (show: boolean) => void;
  resetSessionState: () => void;
}

const initialValues = {
  selectedStore: null,
  selectedShopkeeper: null,
  availableStores: [],
  availableShopkeepers: [],
  hasMoreThanOneStore: false,
  hasMoreThanOneShopkeeper: false,
  showCorrectStoreAlert: false
};

export const useStoresAndShopkeepersStore = create<StoresAndShopkeepersState>()(
  persist(
    (set) => ({
      ...initialValues,
      setSelectedStore: (store) => {
        set({ selectedStore: store });
      },
      setSelectedShopkeeper: (shopkeeper) =>
        set({ selectedShopkeeper: shopkeeper }),
      setAvailableStores: (stores) => {
        set({
          availableStores: stores,
          selectedStore: stores[0],
          hasMoreThanOneStore: stores.length > 1
        });
      },
      setAvailableShopkeepers: (shopkeepers) => {
        set({
          availableShopkeepers: shopkeepers,
          selectedShopkeeper: shopkeepers[0],
          hasMoreThanOneShopkeeper: shopkeepers.length > 1
        });
      },
      setShowCorrectStoreAlert: (show) => set({ showCorrectStoreAlert: show }),
      resetSessionState: () =>
        set({ ...initialValues, showCorrectStoreAlert: true })
    }),
    {
      name: "StoresAndShopkeepersStore",
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);
